<template>
  <div
    class="relative w-full h-full bg-white"
    :style="outerStyle"
  >
    <div
      class="w-full max-w-7xl mx-auto px-8 py-8 pb-20"
      :class="[innerClass]"
    >
      <slot />
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  props: ["innerClass", 'outerStyle'],
};
</script>
